<template>
	<div class="headerBox">
		<div class="headerH">
			<div class="headerLeft" @click="zlk">
				<img src="@/assets/img/ziyuank.svg" alt="" />
				<span>资源库</span>
				<div class="searBoxLeft" @click.stop="" v-if="zxFlag">
					<div class="searBoxItem">
						<div class="searBoxTop">
							<img src="@/assets/img/wangy.svg" alt="" />
							<span>网页资源</span>
						</div>
						<div class="searBoxBot searBoxBot1">
							<span
								@click="
									tzBtn('zlmwHome', {
										tabType: 3
									})
								"
							>
								美文
							</span>
							<span
								@click="
									tzBtn('zlmwHome', {
										tabType: 2
									})
								"
							>
								演讲
							</span>
							<span
								@click="
									tzBtn('zlmwHome', {
										tabType: 1
									})
								"
							>
								歌曲
							</span>
							<span @click="tzBtn('dianyingHome')">电影</span>
						</div>
					</div>
					<div class="searBoxItem">
						<div class="searBoxTop">
							<img src="@/assets/img/wdzy.svg" alt="" />
							<span>文档资源</span>
						</div>
						<div class="searBoxBot">
							<span @click="tzBtn('gongxiangHz', { yzType: '2', classType: 2, tabFtxt: '最新试卷' })">最新试卷</span>
							<span @click="tzBtn('kejianTj', { tabFtxt: '每期课件' })">每期课件</span>
							<span @click="tzBtn('gongxiangHz', { yzType: '2', classType: 1, tabFtxt: '同步课件' })">同步课件</span>
							<span @click="tzBtn('gongxiangHz', { yzType: '2', classType: 3, tabFtxt: '优质课件' })">优质课件</span>
							<span @click="tzBtn('gongxiangHz', { yzType: '2', classType: 8, tabFtxt: '双语新闻', treFlag: false })">双语新闻</span>
							<span class="kzydBox">
								<i @click="tzBtn('gongxiangHz', { yzType: '2', classType: 11, treFlag: false, tabFtxt: '扩展阅读' })">扩展阅读</i>
								<div class="searBoxTips">
									<div class="line"></div>
									<div class="searBoxTip">
										<div class="searBoxTipItem" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 5, treFlag: false, tabFtxt: '双语节目' })">双语节目</div>
										<div class="searBoxTipItem" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 6, treFlag: false, tabFtxt: '英文小说' })">英文小说</div>
										<div class="searBoxTipItem" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 4, treFlag: false, tabFtxt: '荐阅外刊' })">荐阅外刊</div>
										<div class="searBoxTipItem" @click="tzBtn('gongxiangHz', { yzType: '2', classType: 7, treFlag: false, tabFtxt: '优质课' })">优质课</div>
									</div>
									<div class="arrow"></div>
								</div>
							</span>
						</div>
					</div>
					<div class="searBoxItem">
						<div class="searBoxTop">
							<img src="@/assets/img/sti.svg" alt="" />
							<span>试题资源</span>
						</div>
						<div class="searBoxBot">
							<span @click="tzBtn('gongxiangHz', { type: 2, classType: 9, tabFtxt: '每日一听' })">每日一听</span>
							<span @click="tzBtn('zystHome', { txt: '高考真题' })">高考真题</span>
							<span @click="tzBtn('tingliHome', { txt: '听力课本' })">听力课本</span>
							<span @click="tzBtn('zystHome', { txt: '高频词汇', tabFlag: 2 })">高频词汇</span>
						</div>
					</div>
				</div>
			</div>
			<div class="headCont">
				<div class="contItem supHove2" :class="{ active: gjTabFlag == 1 }" @click="gxhz">
					<img src="@/assets/img/gx.svg" alt="" />
					<span>共享互助</span>
				</div>
				<div class="contItem supHove2" :class="{ active: gjTabFlag == 2 }" @click="cygj">
					<img src="@/assets/img/cygj.svg" alt="" />
					<span>常用工具</span>
				</div>
				<div class="contItem supHove2" :class="{ active: gjTabFlag == 3 }" @click="xqsq">
					<img src="@/assets/img/xq.svg" alt="" />
					<span>需求申请</span>
				</div>
			</div>
			<div class="headRig">
				<div class="headRigItem supHove1" @click="headBtn(1)">
					<img src="@/assets/img/qt.svg" alt="" />
					<span>我要组卷</span>
				</div>
				<div class="headRigItem headRigItem1 supHove1" @click="headBtn(2)">
					<img src="@/assets/img/shij.svg" alt="" />
					<span>我的试卷</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'fuHeader',
	data() {
		return {
			zlFlag: false,
			tipFlag: false
		};
	},
	props: {
		zxFlag: {
			default: true,
			type: Boolean
		}
	},
	computed: {
		...mapState(['gjTabFlag'])
	},
	methods: {
		tipBtn() {
			console.log(999);
			this.zlFlag = false;
			this.tipFlag = false;
		},
		headBtn(type) {
			if (type == 1) {
				if (this.$route.fullPath.includes('zujuan')) return;
				this.$router.push({
					path: 'zujuan'
				});
			} else {
				if (this.$route.fullPath.includes('mySj')) return;
				this.$router.push({
					path: 'mySj'
				});
			}
		},
		gxhz() {
			this.$store.commit('gjTabFn', 1);
			if (this.$route.fullPath.includes('gongxiangHz')) return;
			this.$router.push({
				path: 'gongxiangHz',
				query: { type: 2, classType: 10, tabFtxt: '共享互助' }
			});
		},
		zlk() {
			if (this.zxFlag) {
				this.zlFlag = !this.zlFlag;
			}
		},
		cygj() {
			this.$store.commit('gjTabFn', 2);
			if (this.$route.fullPath.includes('changyGj')) return;
			this.$router.push({
				path: 'changyGj',
				query: { tabFtxt: '常用工具' }
			});
		},
		tzBtn(type, qu) {
			this.tipBtn();
			this.$nextTick(() => {
				this.$router.push({
					path: type,
					query: {
						...qu
					}
				});
			});
		},
		xqsq() {
			this.$store.commit('gjTabFn', 3);
			if (this.$route.fullPath.includes('xuqiuSq')) return;
			this.$router.push({
				path: 'xuqiuSq'
			});
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.headerBox {
	background: #ffffff;
	.headerLeft {
		width: 210px;
		height: 53px;
		background: linear-gradient(180deg, #1d7b3a 0%, #1d7b3a 100%);
		border-radius: 12px 12px 0px 0px;
		padding-left: 13px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		color: #ffffff;
		font-size: 18px;
		cursor: pointer;
		position: relative;
		&:hover {
			.searBoxLeft {
				display: block;
			}
		}
		img {
			width: 20px;
			height: 20px;
			margin-right: 18px;
		}
	}
	.headerH {
		height: 53px;
		width: 1200px;
		margin: 0 auto;
		display: flex;
		box-sizing: border-box;
		.headCont {
			display: flex;
			.contItem {
				display: flex;
				align-items: center;
				padding-left: 34px;
				margin-right: 19px;
				color: #000000;
				font-size: 16px;
				cursor: pointer;
				img {
					width: 22px;
					height: 22px;
					margin-right: 6px;
				}
			}
		}
		.headRig {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			flex: 1;
			.headRigItem {
				display: flex;
				width: 114px;
				height: 36px;
				justify-content: center;
				align-items: center;
				color: #fff;
				background: #1576fd;
				border-radius: 7px;
				font-size: 14px;
				margin-left: 10px;
				cursor: pointer;
				img {
					width: 21px;
					height: 21px;
					margin-right: 8px;
				}
			}
			.headRigItem1 {
				background: #ffac3e;
			}
		}
	}
}
.active {
	span {
		// color: #1D7B3A;
	}
}
.searBoxLeft {
	position: absolute;
	display: none;
	top: 53px;
	left: 0;
	z-index: 999;
	width: 210px;
	margin-right: 10px;
	background: #fff;
	padding: 0 8px 8px;
	border-radius: 0px 0px 4px 4px;
	height: 322px;
	box-sizing: border-box;
	box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.08);
	border: 1px solid #f3f4f7;
	.kzydBox {
		position: relative;
		&:hover {
			.searBoxTips {
				display: block;
			}
		}
	}
	.searBoxTips {
		position: absolute;
		display: none;
		top: 100%;
		left: -10px;
		padding-left: 0;
		z-index: 99;
		.line {
			height: 10px;
		}
		.arrow {
			width: 8px;
			height: 8px;
			border: 1px solid #ccc;
			background-color: #fff;
			position: absolute;
			top: 8px;
			left: 50%;
			transform: rotate(45deg) translateX(-50%);
			border-bottom: none;
			border-right: none;
		}
	}
	.searBoxTip {
		width: auto;
		background: #fff;
		height: auto;
		border-radius: 4px;
		border: 1px solid #ccc;
		div {
			color: #666666;
			font-size: 14px;
			cursor: pointer;
			padding: 8px 10px;
			white-space: nowrap;
			&:hover {
				color: #1d7b3a;
			}
		}
	}
	.searBoxItem {
		padding: 14px 0 0;
		border-bottom: 1px solid #f3f4f7;
		&:last-of-type {
			border-bottom: none;
		}
		.searBoxTop {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #000000;
			font-weight: bold;
			img {
				width: 20px;
				height: 20px;
				margin-right: 5px;
			}
		}
		.searBoxBot {
			padding: 13px 2px 0;
			display: flex;
			flex-wrap: wrap;
			color: #666666;
			font-size: 14px;
			span {
				cursor: pointer;
				margin-right: 10px;
				margin-bottom: 13px;
				&:hover {
					color: #1d7b3a;
				}
				&:nth-of-type(3n) {
					margin-right: 0;
				}
			}
		}
		.searBoxBot1 {
			span {
				margin-right: 10px !important;
			}
		}
	}
}
</style>
